<template>
  <path
    d="M21 3.00024H3C1.9 3.00024 1 3.90024 1 5.00024V19.0002C1 20.1002 1.9 21.0002 3 21.0002H21C22.1 21.0002 23 20.1002 23 19.0002V5.00024C23 3.90024 22.1 3.00024 21 3.00024ZM12 18.0002C7.58 18.0002 4 15.3102 4 12.0002C4 8.69024 7.58 6.00024 12 6.00024C16.42 6.00024 20 8.69024 20 12.0002C20 15.3102 16.42 18.0002 12 18.0002Z"
  />
</template>
